import React, { useCallback } from 'react';

import { ModalWrapper } from '@/components/wrappers';

import { BulkPlanReactivationModal } from './BulkPlanReactivationModal.ts/BulkPlanReactivationModal';
import { PlanReactivationResume } from './PlanReactivationResume';
import { SinglePlanReactivationModal } from './SinglePlanReactivationModal';
import { usePlanReactivationModalStore } from './stores';
import { ReactivationSteps } from './types';

export const PlanReactivationModal = () => {
  const handleChangeVisibility = usePlanReactivationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = usePlanReactivationModalStore((state) => state.modalVisible);
  const isBulkMode = usePlanReactivationModalStore((state) => state.isBulkMode);
  const step = usePlanReactivationModalStore((state) => state.step);
  const handleReset = usePlanReactivationModalStore((state) => state.handleReset);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
    handleReset();
  }, [handleChangeVisibility, handleReset]);

  return (
    <ModalWrapper
      testId="PlanReactivationModal"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
      titleBoxStyle={{
        paddingBottom: '8px',
        paddingInline: '12px',
        textAlign: 'center',
      }}
      isClosingByClickOutsideBlocked
    >
      {step === ReactivationSteps.FORM && !isBulkMode && (
        <SinglePlanReactivationModal
          onCancel={handleSetVisible}
        />
      )}
      {step === ReactivationSteps.FORM && isBulkMode && (
        <BulkPlanReactivationModal
          onCancel={handleSetVisible}
        />
      )}
      {step === ReactivationSteps.RESUME && (
        <PlanReactivationResume />
      )}
    </ModalWrapper>
  );
};
